


























import { Prop, Model, Component, Vue, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import { BModal } from 'bootstrap-vue';
import _ from 'lodash';

export interface IBaseNumbersTileConfiguration {
}

@Component({
    components: {
    },
})
export default class BaseNumbersTile extends Mixins(TileComponentMixin) {
    @Prop({required: false})
    public configuration?: IBaseNumbersTileConfiguration;

    @Prop({required: true})
    public pickerTitle: string;

    @Prop({required: true})
    public available: boolean;


    public save() {
        this.$emit('save', {});
    }

}
